import React from "react";
import { AssetsProvider } from "./assets/AssetsContext";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Home from "./components/Home";

function App() {
  return (
    <div className="App">
      <AssetsProvider>
        <Header />
        <Home />
        <Footer />
      </AssetsProvider>
    </div>
  );
}

export default App;
